export {default as Headers} from './Headers'
export {default as Main} from './Main'
export {default as Footer} from './Footer'
export {default as Notices} from './Notices'
export {default as BlockCard} from './BlockCard'
